import authReducer from '@/util/redux/auth';

export default {
  auth: authReducer,
};
